import type { Action as LegacyAction } from '~/flow/types';
import transformBooleanRule from '../transformation/rules';
import reverseTransformBooleanRules from '../transformation/reverse/rules';
import type { WorkflowState } from 'flow/store/redux/state';


export function findAmbiguousRuleErrors(args: {
  legacyActions: LegacyAction[];
  legacyToTransformedThresholdIdMappings: Record<string, string>;
}): WorkflowState['validation']['ambiguousRuleErrors'] {
  const {
    legacyActions,
    legacyToTransformedThresholdIdMappings,
  } = args;

  // builds an object with its keys as values and vice-versa
  const transformedToLegacyThresholdIdMappings = Object.fromEntries(
    Object.entries(legacyToTransformedThresholdIdMappings)
      .map(([legacyId, transformedId]) => [transformedId, Number(legacyId)]),
  );

  return legacyActions.flatMap(action => {
    const { actionId, booleanRule } = action;

    const transformedRule = transformBooleanRule({
      booleanRule,
      legacyToTransformedThresholdIdMap: legacyToTransformedThresholdIdMappings,
    });

    const reverseTransformedRule = reverseTransformBooleanRules({
      booleanRules: transformedRule,
      transformedThresholdsToLegacyThresholdsIdMap: transformedToLegacyThresholdIdMappings,
    });

    // if the transformation logic is correct, these 2 should match
    if (booleanRule !== reverseTransformedRule) {
      return [{
        legacyActionId: actionId,
      }];
    }

    return [];
  });
}
